import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'itemStatus'
})
export class ItemStatusPipe implements PipeTransform {

  lang : string = "";

  constructor(private translateService:TranslateService){
    this.lang = translateService.currentLang
  }

  transform(value: boolean): string {
    return this.lang=="ar" ? (value? "مكتمل" :"غير مكتمل") : (value? "compeleted" :"inCompeleted")
   
  }

}
